/*
 * Mobile - PDP - 10000 - 17500 Bnpl Options  --  variant: Affirm Only
 * Moonshot experiment id: 97245146   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-10-03
 * Audience: MOBILE   Target: pdp_10000_17500   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_m_bnpl_10000_17500
 */
MGExp.run('pdp_m_bnpl_10000_17500', { name: "Mobile - PDP - 10000 - 17500 Bnpl Options / Affirm Only", platform: 'mobile', target: 'pdp_10000_17500' }, function () {
  !(function () {
    let t = [".pdp-payment-options > .m-auto", ".pdp-payment-options > span"],
      e = [];
    async function i(i, a, n, o, m) {
      let s = {
        multi_target_selectors: t,
        page_identifier_selector: "section.prod-page",
        exclude_from_timeout: e,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(i, a, n, o, m, s);
    }
    (i(
      ["div.pdp-payment-options"],
      ".msai-multi-css-marker",
      (t, e) => {
        e[0].classList.add("msai-multi-css-marker");
      },
      ".pdp-payment-options.msai-multi-payment-options-updated{flex-direction:column;align-items:normal}.msai-payment-text{font-size:14px;line-height:1.4;color:#000000;margin-top:8px}.msai-payment-text a{text-decoration:underline;color:inherit}img.msai-inline{display:inline;margin:0 0 4px 0}.pdp-payment-options > .m-auto,.pdp-payment-options > span{display:none}",
    ),
      i(
        ["div.pdp-payment-options", ".affirm-ala-price"],
        ".msai-multi-payment-options-updated",
        function (t, e) {
          const [i, a] = e,
            n = i.querySelector("span#payment-options-btn");
          if (n) {
            const t = document.createElement("div");
            ((t.className = "msai-payment-text"),
              (t.innerHTML = `Pay over time with <img class="m-auto msai-inline" src="https://cdn.shopify.com/s/files/1/0133/9195/3977/files/pay-affirm.png?v=1717438034" alt="affirm">. Starting at ${a.innerText}/mo. <a href='#' class="msai-affirm-trigger">Learn more</a>.`),
              n.parentNode.insertBefore(t, n));
            let e = document.querySelector(".msai-affirm-trigger");
            if (e) {
              let t = document.querySelector(".affirm-modal-trigger");
              t &&
                (e.onclick = function () {
                  t.click();
                });
            }
          }
          let o = document.querySelector(".msai-affirm-trigger");
          if (o) {
            let t = document.querySelector(".affirm-modal-trigger");
            t &&
              (o.onclick = function () {
                t.click();
              });
          }
          i.classList.add("msai-multi-payment-options-updated");
        },
      ));
  })();
});
